module.exports = __webpack_public_path__ + "img/ninja.19aa45c2.png";